<footer class="legal-box">
  <div class="logo-container">
    <img src="../../../assets/images/illustrations/freshai-logo.svg" class="fresh-ai-logo" />
  </div>
  <div class="disclaimer">
    @if (language === 'ENGLISH' && isRecording) {
    <span>
      Wendy’s FreshAi ordering assistant will record and store your voice and use it for quality assurance and AI
      training. By continuing your order with FreshAi, you consent to this recording.
      <b>You can say CREW MEMBER at any time to stop using FreshAi.</b> Visit Wendy’s Privacy Policy by scanning the QR
      code or going to
      <a href="https://www.wendys.com/privacy-policy" class="custom-link">www.wendys.com/privacy-policy</a>.</span
    >
    } @if (language === 'ENGLISH' && !isRecording) {
    <span>
      Wendy’s FreshAi ordering assistant will record your voice and use it for quality assurance. By continuing your
      order with FreshAi, you consent to this recording.
      <b>You can say CREW MEMBER at any time to stop using FreshAi.</b>
      Visit Wendy’s Privacy Policy by scanning the QR code or going to
      <a href="https://www.wendys.com/privacy-policy" class="custom-link">www.wendys.com/privacy-policy</a>.</span
    >
    } @if (language === 'SPANISH' && isRecording) {
    <span>
      El asistente de pedido FreshAi de Wendy's grabará su voz y la utilizará para garantizar la calidad y la
      capacitación en inteligencia artificial. Al continuar con su pedido con FreshAi, usted da su consentimiento para
      esta grabación. <b>Puede decir MIEMBRO DE EQUIPO en cualquier momento para dejar de usar FreshAi.</b> Visite la
      Política de privacidad de Wendy's escaneando el código QR o visitando
      <a href="https://www.wendys.com/privacy-policy" class="custom-link">www.wendys.com/privacy-policy</a>.</span
    >
    } @if (language === 'SPANISH' && !isRecording) {
    <span>
      El asistente de pedido FreshAi de Wendy's grabará su voz y la utilizará para garantizar la calidad. Al continuar
      con su pedido con FreshAi, usted da su consentimiento para esta grabación.
      <b>Puede decir MIEMBRO DE EQUIPO en cualquier momento para dejar de usar FreshAi.</b> Visite la Política de
      privacidad de Wendy's escaneando el código QR o visitando
      <a href="https://www.wendys.com/privacy-policy" class="custom-link">www.wendys.com/privacy-policy</a>.</span
    >
    }
  </div>
  <div class="qr-container">
    <qrcode
      [qrdata]="'https://m-wendys-web.app.link/e/FNmroAdmTUb'"
      [width]="143"
      [errorCorrectionLevel]="'M'"
      class="qr-code"
    ></qrcode>
  </div>
</footer>
